// src/components/CalibrationStatusBadge/CalibrationStatusBadge.jsx
//
// AISC §1.14 Calibration Phase 1 — status badge.
// Mirrors the LifecycleStatusBadge pattern used on Documents Library.

import React from "react";
import { Chip } from "@mui/material";
import { STATUS_LABELS, STATUS_COLORS } from "../../utils/calibrationApi";

export default function CalibrationStatusBadge({ status, size = "small" }) {
  const label = STATUS_LABELS[status] || status || "Unknown";
  const color = STATUS_COLORS[status] || "default";
  return <Chip label={label} color={color} size={size} variant="outlined" />;
}
